import { atom } from 'jotai';
import { SectionKey } from '~/apis/performance/_counterfeit/enforcementAnalysis';
import {
  MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum,
  MarqCommonEnumsPerfPerformanceEnforcementIntervalEnum,
  MarqCommonEnumsPerfPerformanceEnforcementReportableEnum,
} from '~/swagger/data-contracts';
import { EnforcementTopListTabEnum } from '../../@types';

type InnerFilterAtom = {
  overTimeGroupBy: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum;
  overTimeFrequency?: MarqCommonEnumsPerfPerformanceEnforcementIntervalEnum;
  tableTab: EnforcementTopListTabEnum;
  tableGroupBy: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum;
  reportable?: MarqCommonEnumsPerfPerformanceEnforcementReportableEnum;
};

export const innerFilterAtom = atom<InnerFilterAtom>({
  overTimeGroupBy: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum.None,
  tableTab: EnforcementTopListTabEnum.Country,
  tableGroupBy: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum.None,
});

export const overTimeGroupByFilterAtom = atom(
  (get) => {
    return get(innerFilterAtom).overTimeGroupBy;
  },
  (get, set, value: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum) => {
    const prev = get(innerFilterAtom);

    set(innerFilterAtom, {
      ...prev,
      overTimeGroupBy: value,
    });
  }
);

export const overTimeFrequencyFilterAtom = atom(
  (get) => {
    return get(innerFilterAtom).overTimeFrequency;
  },
  (get, set, value?: MarqCommonEnumsPerfPerformanceEnforcementIntervalEnum) => {
    const prev = get(innerFilterAtom);

    set(innerFilterAtom, {
      ...prev,
      overTimeFrequency: value,
    });
  }
);

export const tableTabAtom = atom(
  (get) => {
    return get(innerFilterAtom).tableTab;
  },
  (get, set, value: EnforcementTopListTabEnum) => {
    const prev = get(innerFilterAtom);

    set(innerFilterAtom, {
      ...prev,
      tableTab: value,
    });
  }
);

export const tableGroupByFilterAtom = atom(
  (get) => {
    return get(innerFilterAtom).tableGroupBy;
  },
  (get, set, value: MarqCommonEnumsPerfPerformanceEnforcementGroupByEnum) => {
    const prev = get(innerFilterAtom);

    set(innerFilterAtom, {
      ...prev,
      tableGroupBy: value,
    });
  }
);

const dependentKeyAtom = atom<SectionKey[]>([]);
export const updateDependentKeyAtom = atom(
  (get) => {
    return get(dependentKeyAtom);
  },
  (get, set, sectionKey: SectionKey) => {
    const prev = get(dependentKeyAtom);
    const newList = [...new Set([...prev, sectionKey])];
    set(dependentKeyAtom, newList);
  }
);

export const reportableFilterAtom = atom(
  (get) => {
    return get(innerFilterAtom).reportable;
  },
  (get, set, value?: MarqCommonEnumsPerfPerformanceEnforcementReportableEnum) => {
    const prev = get(innerFilterAtom);

    set(innerFilterAtom, {
      ...prev,
      reportable: value,
    });
  }
);
